import { useQuery } from "@tanstack/react-query";

import { listPosts, type PostVisibility } from "@/adapters/api";
import type { Post } from "@/features/feed/types.ts";
import { toPost } from "@/features/feed/utils/map.ts";
import { useActiveContext } from "@/store/use-active-context";

const MAX_PAGE_SIZE = 100;

export interface PostsFilters {
	visibility: PostVisibility;
	stageId?: string;
	occurredFrom?: string;
	occurredTo?: string;
	authorUserId?: string;
}

export function usePosts(filters: PostsFilters) {
	const activeObraId = useActiveContext((state) => state.activeObraId);

	return useQuery({
		queryKey: [
			"posts",
			activeObraId,
			filters.visibility,
			filters.stageId ?? "",
			filters.occurredFrom ?? "",
			filters.occurredTo ?? "",
			filters.authorUserId ?? "",
		],
		queryFn: async (): Promise<Post[]> => {
			const { items } = await listPosts({
				constructionId: activeObraId ?? undefined,
				visibility: filters.visibility,
				stageId: filters.stageId,
				occurredFrom: filters.occurredFrom,
				occurredTo: filters.occurredTo,
				authorUserId: filters.authorUserId,
				pageSize: MAX_PAGE_SIZE,
			});
			return items.map(toPost);
		},
		staleTime: 30_000,
		refetchInterval: (query) => {
			const hasPending = query.state.data?.some((post) =>
				post.media.some((item) => item.processingStatus === "pending"),
			);
			return hasPending ? 5_000 : false;
		},
	});
}
